import { Component, AfterViewInit, Renderer2, HostListener} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'metanoa';

  inactivityTimeLimit = 15 * 60 * 1000; // 15 minutes in milliseconds
  inactivityTimer: any;


  constructor(private renderer: Renderer2) {}

  ngAfterViewInit() {
    let loader = this.renderer.selectRootElement('#loader');
    this.renderer.setStyle(loader, 'display', 'none');
    
  }

  
}
